import {Injectable} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {LayerUtilService} from './layer-util.service';
import {SpatialUtilService} from '../services/spatial-util.service';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class PrintAreaLayerService {
    private readonly layerId = 'printAreaFeatureLayer_layer';

    private readonly layerSelector = `#${this.layerId}`;

    private readonly featureClass = 'printarea';

    private readonly featureIdAttrName = this.layerUtilService.getFeatureIdAttrName(this.featureClass);

    private readonly featureTypeAttrName = this.layerUtilService.getFeatureTypeAttrName(this.featureClass);

    private svgStyle: string;

    private trustedSvgStyle: SafeHtml;

    constructor(
        private domSanitizer: DomSanitizer,
        private layerUtilService: LayerUtilService,
        private spatialUtilService: SpatialUtilService
    ) {}

    getSvgStyle(): SafeHtml {
        const scaleFactor = this.layerUtilService.getPixelScaleFactor();
        if (scaleFactor === 0) {
            return '';
        }

        const stroke = this.layerUtilService.showFeatures()
            ? this.spatialUtilService.getMapBackground() === 'black'
                ? 'white'
                : 'black'
            : 'transparent';

        const newSvgStyle = `${this.layerSelector} path[${this.featureIdAttrName}] {
            stroke: ${stroke};
            stroke-opacity: 1.0;
            stroke-width: 2;
            fill-opacity: 0;
            fill: none;
        }`;

        if (newSvgStyle === this.svgStyle) {
            return this.trustedSvgStyle;
        }

        this.svgStyle = newSvgStyle;

        this.trustedSvgStyle = this.domSanitizer.bypassSecurityTrustHtml(this.svgStyle);

        return this.trustedSvgStyle;
    }

    init() {
        const printAreaFeatureLayer = this.spatialUtilService.getPrintAreaMapLayer();

        this.layerUtilService.addLayerEventHandler(printAreaFeatureLayer, 'graphic-node-add', (evt: {graphic: any; node: any}) => {
            const featureId = evt.graphic.attributes.id;
            evt.node.setAttribute('id', this.layerUtilService.getFeatureNodeId(this.featureClass, featureId));
            evt.node.setAttribute(this.featureTypeAttrName, `${evt.graphic.attributes.type}`);
            evt.node.setAttribute(this.featureIdAttrName, `${featureId}`);
            this.layerUtilService.setSelectedAttr(evt.node, this.featureClass, featureId);
        });

        this.layerUtilService.addLayerEventHandler(printAreaFeatureLayer, 'edits-complete', () => {
            const printIds = this.spatialUtilService.getPrintAreaGraphics().map((g: any) => g.attributes.id);

            document.querySelectorAll(`${this.layerSelector} path[${this.featureIdAttrName}]`).forEach(path => {
                const printId = parseInt(path.getAttribute(this.featureIdAttrName));
                if (!printIds.includes(printId)) {
                    path.parentNode.removeChild(path);
                }
            });
        });

        this.layerUtilService.addLayerEventHandler(printAreaFeatureLayer, 'mouse-over', (evt: any) => {
            this.layerUtilService.onMouseOver(this.featureClass, evt);
        });

        this.layerUtilService.addLayerEventHandler(printAreaFeatureLayer, 'mouse-out', (evt: any) => {
            this.layerUtilService.onMouseOut(this.featureClass, evt);
        });

        return printAreaFeatureLayer;
    }
}
